import {useQuery} from "react-query";
import {apiCall} from "Apis/BaseApi";
import {IUserDto} from "./Models/IUserDto";

export const USER_CONTEXT_CACHE_KEY = 'USER_CONTEXT_CACHE_KEY'
export const useUserContext = () => {
    return useQuery<IUserDto, unknown>([USER_CONTEXT_CACHE_KEY], async () => {
        return await apiCall<IUserDto>({
            url: `/usercontext`,
            method: 'GET',
        })
    });
}
